import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CounsellorList from "../CounsellorList/CounsellorList";
import { Link, useHistory } from "react-router-dom";
import Seo from "../Seo/Seo";
import {
  counselloerAction,
  coachAction,
  countryAction,
  UniversityAction,
} from "../../redux/common/action";
function PageNotFound() {
  const history = useHistory();
  return (
    <>
      <Seo slug={window.location.pathname} />
      <div>
        <section className=" page-404">
          <div className="headingmains text-center ofc_add page-404-content">
            <h1>Page Not Found!</h1>
            <br></br>
            <p>
              Oops! The page you're looking for isn't available. Please try
              searching again or go back to the previous page.
            </p>
            <div className="buttons-404">
              <Link
                className="btn back-404-btn"
                onClick={() => history.push("/")}
                to={"/"}
              >
                Go Back
              </Link>
              <a
                className="btn link-404-btn"
                href={
                  "https://www.admissify.com/in/study-abroad-in-top-universities-lp/?utm_source=google&utm_medium=cpc&utm_campaign=Brand_search_ad"
                }
                target="_blank"
              >
                Get Free Counselling
              </a>
            </div>
          </div>
          <div className="t-banner-img page-404-img">
            <img
              alt="admissify"
              src="/assets/img/page-not-found-404.webp"
            ></img>
          </div>
        </section>
      </div>
    </>
  );
}
export default PageNotFound;
